/* eslint-disable no-plusplus */
/*
 * @Author: chenhe ch10@meitu.com
 * @Date: 2025-10-17 17:51:16
 * @LastEditors: chenhe ch10@meitu.com
 * @LastEditTime: 2025-10-20 19:14:04
 * @FilePath: /roboneo-web/packages/roboneo-sdk/src/pages/RoboneoChatBoard/useMessageStore.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
  SendMessageFn, UserMessage, Message, HistoryDetail,
} from '$/pages/RoboneoChatBoard/type';
import {
  StateCreator, create,
} from 'zustand';
import { immer } from 'zustand/middleware/immer';

export type SetAutoScrollFn = (value: boolean) => void;

export interface IMessagesState {
  sendMessagesHandler: SendMessageFn | null;
  reloadDataHandler: null | ((roomId: string) => Promise<void>);
  /**
   * 由 `useMessageScroll` 注入的滚动控制方法，供外部在需要时手动开/关自动滚动
   */
  setAutoScroll: SetAutoScrollFn | null;
  messages: (Message | UserMessage)[][];
  messagesFetched: boolean;
  isEmptyMessages(): boolean;
  enableShared: boolean;
  historyDetail: HistoryDetail | null;
}
const messagesState: StateCreator<IMessagesState, [
  ['zustand/immer', never],
]> = (set, get) => ({
  sendMessagesHandler: null,
  reloadDataHandler: null,
  setAutoScroll: null,
  messages: [],
  messagesFetched: false,
  enableShared: false,
  historyDetail: null,
  isEmptyMessages() {
    return get().messages.length === 0;
  },
});
const useMessagesStore = create<IMessagesState>()(immer(messagesState));
export default useMessagesStore;

/**
 * 设置重新加载数据函数
 * @export
 * @param {*} fn
 */
export function registerReloadDataMethod(fn: (roomId: string) => Promise<void>) {
  useMessagesStore.setState(() => ({ reloadDataHandler: fn }));
}
/**
 * 设置发送函数
 * @export
 * @param {*} fn
 */
export function registerSendMessageMethod(fn: SendMessageFn) {
  useMessagesStore.setState(() => ({ sendMessagesHandler: fn }));
}

/**
 * 注册/清理自动滚动控制方法（通常由 ChatBoard 内部注册，外部通过 store 调用）
 */
export function registerSetAutoScrollMethod(fn: SetAutoScrollFn | null) {
  useMessagesStore.setState(() => ({ setAutoScroll: fn }));
}

export function setChatMessages(messages: (Message | UserMessage)[][]) {
  useMessagesStore.setState(() => ({ messages }));
}

export function setMessagesFetched(messagesFetched: boolean) {
  useMessagesStore.setState(() => ({ messagesFetched }));
}
export function setEnableShared(enableShared: boolean) {
  useMessagesStore.setState(() => ({ enableShared }));
}

export function setHistoryDetail(historyDetail: HistoryDetail | null) {
  useMessagesStore.setState(() => ({ historyDetail }));
}
